// extracted by mini-css-extract-plugin
module.exports = {"success":"#00703c","neutral":"#777","neutral200":"#c6c6c6"};